var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "matrix(-1 0 0 1 12 0)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_543_2194",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_543_2194",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC2UlEQVR4nO2dTUodQRSFLySYxRhngUBw4CLcSEaZOnQUEjDJBjIQ96CLiHEZiqR7GDmhoIWHef26+lXVvbeqzjfTyT33fK9/RF63CCGEEEIIIYQQQgghkQA4AvAVwG8AI9pnnHb9AuCt2QcFwBsA3wE8oV+eAHwDcGBR/o319o64VpUA4If1xg650Dzn93zameMvgEMNAeGCS7bzWUPA3cxwAtxqCBjY9Cx/NASQHVCAMRRgDAUY406AVA687esuUG/7ugvU277uAvW2r7tAve3rLlBv+7oL1Nu+7gL1tu/aQL0hFGALBRhDAcZQgDEUYAwFGEMBxrgTYD1fm9z7JhdgPV+b3PsmF2A9X5vc+yYXYD1fm9z7JhdgPV+b3PsmF2A9X5vc+yYXYD1fm9z7JhdgPV+b3PtWV4A1FGAMBRhDAcZ0L0DyXu8+hC9dUIDhJ3CthNzztwVyjZTZOVpCifkvw7hGyu0dJaHU/M0grpGyuy9KKDn/OYRrpPz+OyWUnt+9gCUJUho4R5SYk6Ax2DWSnv88RUJywRFDXSN58u8tIbngiIGukXz595KQXHDEMNdI3vyrJSQXHDHINZI//9mKbo6TC44Y4hopkz/6SCgOnCPl8vuQAOdI2fz2EuAcWc7/qWoJcI7E7VCvBDhH4veoUwL8c7xil7PEWdG3qNlAHc92Pmn2SEAdjM1KQD2MTUpAXYzNSajwwa1jUxIqfXTx0Mzd0fTmiBoZmzgSwms7pke118jQxJEwvbajVgZlCaclBBxMr+2olUFJwiWA19kFbEi44OnIoPwXIg7DmyPCywsqvEUdCh0J/5Uffi5yOuoNLN8dXW0p/xWAn27+qdOwhKuF8p+hhAISYsunhFxsXBPmzvnh97v4mC1MrwA43bP8wL1d8kZBfPmBX9Z5ey7/EcA768wtno5iy39vnbfXvxNYvqEElm8ogeWLMuE+H8BDuNuZu+D+AymuKas/Y4OOAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestion);
export default __webpack_public_path__ + "static/media/gestion.c20a6909f4f16aaa773b23794a957b9e.svg";
export { ForwardRef as ReactComponent };